import * as React from 'react';
import { MenuItem, TextField } from '@mui/material';

import { codeLabel, comboLabel, simpleLabel } from '../core/corecombo';
export class BasicCodeCombo extends React.Component<any> {

  // render(){
  //   const {label,items,value,onChange} = this.props;
  //   return (
  //     <TextField
  //       select
  //       size="small"
  //       label={label}
  //       value={value}
  //       onChange={(e) => onChange(e.target.value)}
  //       fullWidth
  //     >
  //       <MenuItem value="">All</MenuItem>
  //       {items.map((x:any) => (
  //         <MenuItem key={x.shc} value={x.shc}>{comboLabel(x)}</MenuItem>
  //       ))}
  //     </TextField>
  //   );
  // }

  render(){
    const {label,items,value,onChange,type='SIMPLE',...others} = this.props;
    const t = type?.toUpperCase();
    const labelFn = t==='CODE'?codeLabel:t==='COMBO'?comboLabel:simpleLabel;
    return (
      <TextField
        select
        size="small"
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        fullWidth
        {...others}
      >
        <MenuItem value="">All</MenuItem>
        {items.map((x:any) => (
          <MenuItem key={x.shc} value={x.shc}>{labelFn(x)}</MenuItem>
        ))}
      </TextField>
    );
  }
}

